export enum DividerTypes {
  Regular = 'REGULAR',
  Light = 'LIGHT',
  Bold = 'BOLD',
}
